var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarVoz({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dar-voz",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "limit",
    d: "M0,0H24V24H0Z",
    transform: "translate(0 -2)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_200",
    "data-name": "Trazado 200",
    d: "M11,21A10,10,0,0,1,1,11V1.667A.667.667,0,0,1,1.667,1H11a10,10,0,1,1,0,20Z",
    transform: "translate(1 -1)",
    fill: "#4132b4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_37",
    "data-name": "Elipse 37",
    cx: 1.333,
    cy: 1.333,
    r: 1.333,
    transform: "translate(10.667 8.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_38",
    "data-name": "Elipse 38",
    cx: 1.333,
    cy: 1.333,
    r: 1.333,
    transform: "translate(14.667 8.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_39",
    "data-name": "Elipse 39",
    cx: 1.333,
    cy: 1.333,
    r: 1.333,
    transform: "translate(6.667 8.667)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarVoz);
export default __webpack_public_path__ + "static/media/dar-voz.fe75881212f38a7b9e70a99a175bc588.svg";
export { ForwardRef as ReactComponent };